import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

import InstallTech_Stretch from "@/_images/InstallTech_Stretch.png";

import PermPhoneMsgOutlinedIcon from "@mui/icons-material/PermPhoneMsgOutlined";
import Link from "@mui/material/Link";
import HistoryIcon from "@mui/icons-material/History";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { LifeSafer } from "../../_helpers/BrandConstants";
import { brandColors } from "../../_components/brandedComponent/BrandedColors";
import FreeCancellationIcon from "@mui/icons-material/FreeCancellation";
import PropTypes from "prop-types";

const WrapUp = ({ appointmentData }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t,i18n } = useTranslation();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  return (
    <Grid
      sx={{
        // py: { xs: "25px", md: "25px" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        // minHeight: "100vh",
      }}
    >
      <Box
        component="img"
        src={InstallTech_Stretch}
        alt="Smiling driver"
        sx={{
          width: "100%",
          mb: { xs: 3, md: 5 },
          objectFit: "cover",
        }}
      />

      <Box
        sx={{
          textAlign: "left",
          maxWidth: 700,
          px: { xs: 4, md: 4 },
        }}
      >
        <Grid>
          <Typography
            variant={isMobile ? "h5" : "h4"}
            fontWeight={700}
            mb={2}
            color="text.primary"
          >
            {/* {isMobile ? t("speed.readyNextStep") : t("speed.allSet")} */}
            {t("steps.installationBooked")}
          </Typography>
          <Typography
            sx={{
              color: `${brandColors[brand].primary}`,
              ml: isMobile ? 0 : 1,
            }}
          >
            {t("steps.isaInstallationBooked", {
              appointmentDate: appointmentData && appointmentData[0]?.appointmentDate,
              appointmentTime: appointmentData && appointmentData[0]?.appointmentTime,
            })} { appointmentData && appointmentData[0]?.appointmentDate?".":"" }

          </Typography>

          <Typography
            sx={{
              fontWeight: "bold",
              mb: 1,
              mt: 2,
              color: `${brandColors[brand].primary}`,
            }}
          >
            {t("formLead.nextSteps")}
          </Typography>
          <Grid
            variant="body1"
            // color="text.secondary"
            mb={1.5}
            sx={{
              lineHeight: 1.6,
              display: "flex",
              alignItems: "start",
              gap: 1,
              fontWeight: 500,
              color: `${brandColors[brand].primary}`,
            }}
          >
            <span style={{ position:"relative" }}>
            <FreeCancellationIcon sx={{ color: "#76bc21" }} />
            <span style={{ position:"absolute", left:"5.5px", top:"10px",width:"9px",height:"9px", borderRadius:"100%",backgroundColor:"#fff" }}></span>
            </span>
            <Typography>{t("steps.wrapUpDescription1")}</Typography>
          </Grid>

          <Grid
            variant="body1"
            color="text.secondary"
            sx={{
              lineHeight: 1.6,
              display: "flex",
              alignItems: "start",
              gap: 1,
              fontWeight: 500,
              color: `${brandColors[brand].primary}`,
            }}
          >
            <PermPhoneMsgOutlinedIcon sx={{ color: "#76bc21" }} />

            {/* <span dangerouslySetInnerHTML={{ __html: t("steps.wrapUpDescription2", {anyTime:isMobile?"<strong style='color:#1C355E'><i>any time</i></strong>": "any time"}) }} /> */}
            <Typography>
            {!isMobile ? (
                t("steps.wrapUpDescription2")
            ) : (
               <span
                dangerouslySetInnerHTML={{
                  __html: t("steps.wrapUpDescription2Mobile", {
                    anyTime: i18n.language === "es"?"<strong style='color:#1C355E'><i>en cualquier momento</i></strong>": "<strong style='color:#1C355E'><i>any time</i></strong>",
                  }),
                }}
              />
            )}
          </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            // display: ,
            justifyContent: "flex-start",
            maxWidth: 700,
            pl: 2,
            mt: 4,
            color: `${brandColors[brand].primary}`,
          }}
        >
          <Typography>{t("steps.thankYouIsa")}</Typography>
          <Typography>{t("steps.lookForward")}</Typography>
        </Grid>
      </Box>

      <Grid
        spacing={4}
        mt={4}
        sx={{
          display: "flex",
          maxWidth: 700,
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 1, md: 4 },
          gap: { xs: 0.5, md: 0 },
          width: "100%",
          //   mt: { xs: "auto", md: 4 },
          mt: 4,
          fontWeight: "600",
        }}
      >
        <Link
          underline="none"
          href="https://www.lifesaferisa.com"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          <HistoryIcon
            style={{
              color: `${brandColors[brand].primary}`,
            }}
          />
          <Typography
            style={{
              color: `${brandColors[brand].primary}`,
              textTransform: "uppercase",
            }}
          >
            {t("speed.backTo")} {t("speed.lifesaferISA")}
          </Typography>
        </Link>
      </Grid>
    </Grid>
  );
};

WrapUp.propTypes = {

  referralSiteData: PropTypes.String,
  appointmentData: PropTypes.object,
};

export default WrapUp;
